import PropTypes from 'prop-types';

import CustomSVGIcon from './CustomSVGIcon';

const Autorenew = ({ color = '', ...other }) => {
	return (
		<CustomSVGIcon {...other}>
			<path
				d="M10.5,4.54687498 L10.5,7.27187496 L14.2520658,3.63749998 L10.5,0 L10.5,2.72812499 C7.7681669,2.72502881 5.25118979,4.16386211 3.93173275,6.48288367 C2.61227571,8.80190524 2.69956611,11.6333859 4.15952453,13.8718749 L5.52947983,12.5468749 C5.09958374,11.7630556 4.87800906,10.8877085 4.88479498,10 C4.88656349,6.99269099 7.3979812,4.55376409 10.5,4.54687498 Z M16.8404755,6.12812497 L15.4705202,7.45312496 C16.3932013,9.14274062 16.3352167,11.1775169 15.3177192,12.8151685 C14.3002216,14.4528201 12.4720044,15.4538659 10.5,15.4531249 L10.5,12.7281249 L6.74793419,16.3624999 L10.5,19.9999999 L10.5,17.2718749 C13.2318331,17.2749711 15.7488102,15.8361378 17.0682673,13.5171162 C18.3877243,11.1980947 18.3004339,8.36661398 16.8404755,6.12812497 Z"
				id="autorenew"
				fill={color}
			/>
		</CustomSVGIcon>
	);
};

Autorenew.propTypes = {
	color: PropTypes.string,
};

export default Autorenew;
